export interface StackTodoTask {
  order: any;
  task: string;
  due?: string | Date;
}

export function todoDueTimestamp(due?: string | Date): number {
  if (!due) {
    return Number.POSITIVE_INFINITY;
  }
  const parsed = due instanceof Date ? due : new Date(due);
  if (isNaN(parsed.getTime())) {
    return Number.POSITIVE_INFINITY;
  }
  return parsed.getTime();
}

export function compareTodoTodayByDue(a: StackTodoTask, b: StackTodoTask): number {
  const dueDiff = todoDueTimestamp(a.due) - todoDueTimestamp(b.due);
  if (dueDiff !== 0) {
    return dueDiff;
  }
  return String(a.task || '').localeCompare(String(b.task || ''));
}

export function holdGeneratedInitials(order: any): string {
  const logs = Array.isArray(order?.log) ? order.log : [];
  for (let i = 0; i < logs.length; i++) {
    const item = String(logs[i]?.item || '').trim().toUpperCase();
    if (item === 'HOLD') {
      const initials = String(logs[i]?.initials || '').trim();
      if (initials) {
        return initials.toUpperCase();
      }
    }
  }
  const activity = order?.products?.[0]?.frame?.activity;
  if (Array.isArray(activity)) {
    for (let i = activity.length - 1; i >= 0; i--) {
      const status = String(activity[i]?.status || '').trim().toUpperCase();
      if (status === 'HOLD') {
        const by = String(activity[i]?.completedBy || '').trim();
        if (by) {
          return by.toUpperCase();
        }
      }
    }
  }
  return String(order?.initials || '').trim().toUpperCase();
}

/** Shared Stack job-row columns that stay fixed across every section. */
export const STACK_SHARED_COLUMNS = [
  'status',
  'vendorName',
  'model',
  'color',
  'patient',
  'invoiceNumber',
  'view',
  'log',
] as const;

/**
 * Build displayed columns for a Stack job table.
 * Shared columns stay in the same order; section-specific fields insert
 * between Color and Patient so Status → Vendor → Model → Color → Patient
 * → Invoice → View → Log remain aligned while scanning.
 */
export function stackOrderColumnsForView(tableView = 'orders'): string[] {
  const sharedStart = ['status', 'vendorName', 'model', 'color'];
  const sharedEnd = ['patient', 'invoiceNumber', 'view', 'log'];
  switch (tableView) {
    case 'hold':
      return [...sharedStart, 'eta', 'payment', ...sharedEnd];
    case 'generic-hold':
      return [...sharedStart, 'holdInitials', ...sharedEnd];
    case 'awaiting':
      return [...sharedStart, 'orderDate', 'referenceNumber', ...sharedEnd];
    default:
      return [...sharedStart, 'size', 'patientStock', ...sharedEnd];
  }
}

